module.exports = __webpack_public_path__ + "7e4b29ba/img/ion_calendar-number.3ac5bd07.svg";